import { lazy } from 'react'
import { Briefcase, Building2, Clock, CreditCard, KeyRound, ShieldCheck, Users } from 'lucide-react'
import { hasModule } from '../access/modules.js'
import { isAdmin } from '../admin/utils/isAdmin.js'

/**
 * Sous-pages de « Compte ». `visible(user)` décide de l'affichage (droits, organisation).
 * Chaque écran est une page existante, chargée à la demande.
 */
export const ACCOUNT_SECTIONS = [
  {
    key: 'credits',
    label: 'Crédits',
    icon: CreditCard,
    visible: () => true,
    component: lazy(() => import('../../pages/BuyCredits.jsx')),
  },
  {
    key: 'activite',
    label: 'Activités',
    icon: Clock,
    visible: () => true,
    component: lazy(() => import('../../pages/ActivityHistory.jsx')),
  },
  {
    // Comptes externes utilisés par JLP (LinkedIn…) ; la liste des services dépend des droits.
    key: 'authentification',
    label: 'Authentification',
    icon: KeyRound,
    visible: () => true,
    component: lazy(() => import('./pages/AuthenticationPage.jsx')),
  },
  {
    // Société(s) au nom de laquelle on vend : bloc « Prestataire » des contrats.
    key: 'entreprise',
    label: 'Mon entreprise',
    icon: Briefcase,
    visible: () => true,
    component: lazy(() => import('./pages/MyCompanyPage.jsx')),
  },
  {
    key: 'organisation',
    label: 'Organisation',
    icon: Users,
    visible: (user) => Boolean(user?.organization),
    component: lazy(() => import('../../pages/Organization.jsx')),
  },
  {
    key: 'agences',
    label: 'Agences',
    badge: 'USTS',
    icon: Building2,
    visible: (user) => hasModule(user, 'projects_auto'),
    component: lazy(() => import('../../pages/Agencies.jsx')),
  },
  {
    key: 'admin',
    label: 'Administration',
    icon: ShieldCheck,
    visible: (user) => isAdmin(user),
    component: lazy(() => import('../admin/pages/AdminPage.jsx')),
  },
]
